import { useNavigation } from '@/context/NavigationContext';
import { useWidgetConfig } from '@/context/WidgetConfigContext';
import { COLORS } from '@/helpers/constants/theme';
import { useHoverBackground } from '@/hooks/useHoverBackground';
import { E_AppRoutes } from '@/types/Routes';

export const NotFound = () => {
  const { navigateTo } = useNavigation();
  const { theme } = useWidgetConfig();
  const { backgroundColor = COLORS.BRAND_PRIMARY, textColor = COLORS.TEXT_INVERSE } =
    theme?.primaryButton ?? {};

  const { backgroundColor: hoverBackground, hoverHandlers } = useHoverBackground({
    baseColor: backgroundColor,
  });

  return (
    <div className='flex h-full flex-col items-center justify-center gap-4 space-y-4 p-6 text-center'>
      <h2>Join Our Loyalty Program</h2>
      <h3 className='max-w-md'>🎁 You're missing out! 🎁</h3>
      <h6 className='max-w-md'>Sign up today to unlock exclusive rewards and special perks</h6>
      <button
        className='rounded-lg px-6 py-3 font-semibold shadow-md transition'
        {...hoverHandlers}
        style={{
          backgroundColor: hoverBackground,
          color: textColor,
        }}
        onClick={() => navigateTo(E_AppRoutes.UNREGISTERED_CUSTOMER)}
      >
        Register Now
      </button>
    </div>
  );
};
